// auth.interceptor.ts
import { Injectable, Injector } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, from, throwError } from "rxjs";
import { switchMap, catchError } from "rxjs/operators";
import { AuthService } from "../services/auth.service";
import { Router } from "@angular/router";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Lazily resolve AuthService to avoid circular/timing issues
    const authService = this.injector.get(AuthService);
    const router = this.injector.get(Router);

    // Convert the Promise<string|null> into an Observable<string|null>
    return from(authService.getToken()).pipe(
      switchMap((token) => {
        // If we got a token, clone the request and set the header
        const authReq = token
          ? req.clone({
              headers: req.headers.set("Authorization", `Bearer ${token}`),
            })
          : req;
        // Pass on the (possibly cloned) request and handle 401 errors
        return next.handle(authReq).pipe(
          catchError((error: HttpErrorResponse) => {
            // If we get a 401 Unauthorized, clear auth state and redirect to login
            if (error.status === 401) {
              console.warn(
                "401 Unauthorized - clearing auth state and redirecting to login"
              );
              // Use setTimeout to avoid navigation during HTTP request
              setTimeout(async () => {
                await authService.logout();
              }, 0);
            }
            return throwError(() => error);
          })
        );
      }),
      // If getToken() itself throws or rejects, just continue without auth header
      catchError(() => next.handle(req))
    );
  }
}
